import { setTheme, getTheme } from "@/common/theme/index";

const state = {
    sidebar: {
        opened: true
    },
    locale: '',
    theme: getTheme()
}

type stateType = typeof state;

export enum MutationsType {
    setTheme = "SET_THEME"
}

export enum ActionsType {
    setTheme = "setTheme"
};

const mutations = {
    TOGGLE_SIDEBAR: (state: any) => {
        state.sidebar.opened = !state.sidebar.opened
    },
    SET_LANGUAGE: (state: any, language: string) => {
        state.locale = language
    },
    [MutationsType.setTheme]: (state: stateType, theme: string) => {
        state.theme = theme;
        setTheme(theme);
    }
}

const actions = {
    toggleSideBar ({ commit }: { commit: Function}) {
        commit('TOGGLE_SIDEBAR')
    },
    setLanguage({ commit }: { commit: Function }, language: string) {
        commit('SET_LANGUAGE', language)
    },
    [ActionsType.setTheme]({commit}, theme: string) {
        commit(MutationsType.setTheme, theme)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
